<!--
 * @Author: xiaokun
 * @Date: 2020-06-09 10:58:55
 * @LastEditors: xiaokun
 * @LastEditTime: 2020-06-23 14:11:33
 * @Description: 执行情况
-->
<template>
  <div class="execute-condition">
    <mk-tabs
      :value="curTaskId"
      tab-position="left"
      @tab-click="tabClick"
    >
      <mk-tab-pane
        v-for="(item,index) in taskList"
        :key="item._id"
        :name="item._id"
        :label="'任务' + (index+1)"
      >
        <!-- 任务信息 -->
        <div class="task-title">
          <!-- 任务时间 -->
          <div class="exec-time">
            任务时间：{{ item.execTime }}
          </div>
          <!-- 任务名称 -->
          <div class="show-name">
            分享{{ item.materialTypeCn }}《{{ item.showName }}》
          </div>
        </div>
        <!-- 任务员工执行情况 -->
        <div class="task-sale-condition">
          <div class="task-sale-condition-top">
            <!-- 状态筛选 -->
            <mk-select
              v-model="curTaskStatus"
              clearable
              size="mini"
              placeholder="执行状态"
              @change="changeSelectTaskStatus"
              @clear="handelOnClearClick"
            >
              <mk-option
                v-for="statusItem in taskStatus"
                :key="statusItem.value"
                :label="statusItem.label"
                :value="statusItem.value"
              >
              </mk-option>
            </mk-select>

            <export-xlsx
              :api="taskPerformExportGet"
              text="导出执行数据"
              type="default"
              width="120px"
              icon="el-icon-download"
            />
          </div>
          <!-- 员工明细 -->
          <template v-if="saleList.length">
            <div class="sale-details">
              <!-- 标题 -->
              <div class="sale-details-title sale-details-common">
                <div class="sale-name">
                  员工
                </div>
                <div class="sale-phone-number">
                  电话号码
                </div>
                <div class="sale-status">
                  状态
                </div>
              </div>
              <!-- 员工表格 -->
              <div
                v-for="saleItem in saleList"
                :key="saleItem.UserID"
                class="sale-details-content"
              >
                <div class="sale-item sale-details-common">
                  <div
                    class="sale-name ellipsis"
                  >
                    {{ saleItem.name }}<span v-if="saleItem.saleStatus==='stop'">(已离职)</span>
                  </div>
                  <div class="sale-phone-number">
                    {{ saleItem.phone }}
                  </div>
                  <div class="sale-status">
                    <!-- 0:未读，1:未完成，2:已完成 -->
                    <div
                      class="status-spot"
                      :style="`background: ${backgroundFn(saleItem.status)}`"
                    />
                    <span>
                      {{ saleStatus(saleItem.status) }}
                    </span>
                  </div>
                </div>
              </div>
              <!-- 分页 -->
              <mk-pagination
                small
                layout="prev, pager, next"
                :total="total"
                :current-page="page"
                :pager-count="5"
                hide-on-single-page
                @current-change="currentChange"
              >
              </mk-pagination>
            </div>
          </template>
          <div
            v-else-if="item.status===0"
            class="no-data"
          >
            <div class="no-data-img">
              <img
                src="@/assets/images/no-data.png"
                class="img"
              >
            </div>
            <div class="no-data-txt">
              该任务尚未开始
            </div>
          </div>
          <div
            v-else
            class="no-data"
          >
            <div class="no-data-img">
              <img
                src="@/assets/images/no-data.png"
                class="img"
              >
            </div>
            <div class="no-data-txt">
              暂无数据
            </div>
          </div>
        </div>
        <!-- 任务状态 -->
      </mk-tab-pane>
    </mk-tabs>
  </div>
</template>
<script>
import { materialFormat } from '@/utils/userActionFormat'
export default {
  name: 'ExecuteCondition',
  components: {},
  props: {},
  data () {
    return {
      // curTask
      curTask: '',
      // 任务列表
      taskList: [],
      // 任务状态
      taskStatus: [{
        value: 0,
        label: '未读' },
      {
        value: 1,
        label: '未完成' },
      {
        value: 2,
        label: '已完成' }
      ],
      // 当前所选任务状态
      curTaskStatus: null,
      // 任务下员工执行状态明细
      saleList: [],
      // 当前任务id
      curTaskId: '',
      // 当前任务下员工在总数
      total: 0,

      page: 1,
      pageSize: 10
    }
  },
  computed: {
    // 导出执行数据api
    taskPerformExportGet () {
      return {
        name: MKMATERIALSVC.TimingplanTaskApi.taskPerformExportGet,
        params: {
          planId: this.$route.query.id,
          taskId: this.curTaskId
        }
      }
    }
  },
  created () {
    this.getPlanTaskList()
  },
  methods: {
    // 获取计划子列表
    async getPlanTaskList () {
      const res = await BIZAPIS.MarketingPlanMetaApi.timingPlanMetaGet({
        planId: this.$route.query.id
      })
      if (res.success) {
        res.data.data.forEach(item => {
          // 类型的中文
          item.materialTypeCn = materialFormat(item.materialType)
        })
        // 默认获取第一个任务的执行详情
        this.curTaskId = res.data.data[0]._id
        // 调用员工执行明细
        this.taskPerformStatus()

        this.taskList = res.data.data
      }
    },
    // 切换任务状态
    changeSelectTaskStatus (val) {
      // 复制状态
      this.curTaskStatus = val
      // 重置页数
      this.page = 1
      // 调用接口
      this.taskPerformStatus()
    },
    // 员工执行明细
    async taskPerformStatus () {
      let params = {
        planId: this.$route.query.id,
        taskId: this.curTaskId,
        page: this.page,
        pageSize: this.pageSize
      }
      // 执行状态 0:未读，1:未完成，2:已完成
      if (this.curTaskStatus !== null && this.curTaskStatus !== '') {
        params.performStatus = this.curTaskStatus
      }
      const res = await MKMATERIALSVC.TimingplanTaskApi.taskPerformStatusPost(params)
      if (res.success) {
        this.total = res.data.total
        this.saleList = res.data.data
      }
    },
    // 状态处理
    saleStatus (val) {
      switch (val) {
        case 0:
          return '未读'
        case 1:
          return '未完成'
        case 2:
          return '已完成'
      }
    },
    // 状态颜色处理
    backgroundFn (val) {
      switch (val) {
        case 0:
          return '#52C41A'
        case 1:
          return '#36CBCB'
        case 2:
          return '#009CFF'
      }
    },
    // 分页
    currentChange (val) {
      this.page = val
      // 调用接口
      this.taskPerformStatus()
    },
    // 切换任务
    tabClick (val) {
      this.curTaskId = val.name
      // 页数重置为1
      this.page = 1
      // 清空任务状态
      this.curTaskStatus = null
      // 调用接口
      this.taskPerformStatus()
    },
    // 清空所选状态
    handelOnClearClick () {
      this.curTaskStatus = null
    }

  }
}
</script>
<style lang='scss' scoped>
.execute-condition {
  display: flex;
  height: 100%;

  /deep/ .el-tabs {
    width: 100%;

    .el-tabs__header {
      margin-right: 0;

      .is-left::after {
        width: 1px;
        color: #e8e8e8;
      }
    }

    .el-tabs__item {
      padding: 0 15px;
      font-size: 13px;
      color: #595959;
    }

    .is-active {
      color: #009cff;
    }

    .el-tabs__nav {
      transform: translateY(10px) !important;

      .el-tabs__active-bar {
        height: 36px !important;
      }
    }
  }

  .task-title {
    padding: 8px 10px;
    font-size: 13px;
    width: 100%;
    border-bottom: 1px solid #f0f0f0;

    .exec-time {
      color: #262626;
      line-height: 20px;
    }

    .show-name {
      color: #595959;
      line-height: 20px;
    }
  }

  .task-sale-condition {
    padding: 10px;
    padding-top: 8px;

    /deep/ .mk-select {
      flex: 1;
      margin-right: 10px;

      .el-input__inner {
        height: 28px;
      }

      .el-input__icon {
        line-height: 28px;
      }
    }

    &-top {
      display: flex;
    }

    .sale-details {
      .sale-details-title {
        color: #475166;
        font-size: 12px;
        margin-top: 8px;
        font-weight: 500;
        line-height: 17px;
      }

      .sale-details-common {
        display: flex;
        justify-content: space-between;
      }

      .sale-item {
        display: flex;
        margin-top: 10px;
        line-height: 20px;
        color: #595959;
        font-size: 13px;
      }

      .sale-name {
        width: 120px;
        margin-right: 10px;
      }

      .sale-phone-number {
        width: 137px;
      }

      .sale-status {
        display: flex;
        align-items: center;
        width: 60px;

        .status-spot {
          width: 6px;
          height: 6px;
          border-radius: 50%;
          margin-right: 4px;
        }
      }

      /deep/ .el-pagination {
        margin-top: 10px;
        color: #8c8c8c;
        text-align: right;
        font-weight: normal;
      }
    }
  }

  .no-data {
    text-align: center;
    font-size: 14px;
    line-height: 14px;
    padding: 110px 0;
    color: #bfbfbf;

    .no-data-img {
      margin-bottom: 8px;

      img {
        width: 80px;
      }
    }
  }
}
</style>
